<template>
  <div>
    <user-modal ref="edit_user" v-on:done="updateUsers"></user-modal>
    <div class="row">
      <div class="col" v-if="users.length == 0">
        <h4>{{ 'no_users' | t }}</h4>
      </div>
    </div>
    <div class="row mb-4" v-for="user in users" :key="user.id">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <h4>{{ user.first_name + ' ' + user.last_name }}</h4>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <label>{{ 'email' | t }}</label>
              </div>
              <div class="col-md-9">
                <a href="">{{ user.email }}</a>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label>{{ 'updated_at' | t }}</label>
              </div>
              <div class="col-md-9">{{ user.updated_at | datetime }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label>{{ 'created_at' | t }}</label>
              </div>
              <div class="col-md-9">{{ user.created_at | datetime }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label>{{ 'user_group' | t }}</label>
              </div>
              <div class="col-md-9" v-if="user.user_group">{{ user.user_group.name }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label>{{ 'marketing_consent' | t }}</label>
              </div>
              <div class="col-md-2">{{ (marketingConsent(user) != null) | t }}</div>
              <div v-if="marketingConsent(user) != null" class="col-md-2">
                {{ marketingConsent(user).created_at | datetime }}
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary mr-2" @click="$refs.edit_user.open(user)">{{ 'edit' | t }}</button>
            <button class="btn btn-danger" @click="deleteUser(user)">{{ 'delete' | t }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import clientApi from '@/store/clientapi';

export default {
  props: { value: Array },
  computed: {
    users() {
      return this.value;
    }
  },
  methods: {
    deleteUser(user) {
      clientApi.destroy('users', user.id).then((data) => {
        this.updateUsers();
        Alerts.success({
          title: 'User deleted',
          detail: 'The user was deleted'
        });
      });
    },
    updateUsers() {
      this.$emit('done', []);
    },
    marketingConsent(user) {
      return user?.consents?.find((c) => c.key == 'marketing');
    }
  }
};
</script>
